import { ProductContext } from '../../../../types/ProductContext';
import { QuickStatsMessage } from '../../../../types/QuickStatsMessage';
import { authorizedAxiosInstance } from '../instances/AuthorizedAxiosInstance';

export const getStats = async (): Promise<QuickStatsMessage> => {
    const response = await authorizedAxiosInstance.get<QuickStatsMessage>(`/v1/quickstats`, {
        params: {
            types: ProductContext.LUBES,
        },
    });

    return response.data;
};
